import { composeStyle } from '@xhs/yam-beer/core/system/compose'
import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

const disabledCircleState = '&[disabled]:not([data-is-checked="true"]) + div'
const disabledCheckedCircleState = '&[data-is-checked="true"][disabled] + div'
const checkedCircleState = '&[data-is-checked="true"]:not([disabled]) + div'

export default function initStyle() {
  return [registerThemeSpec('cmp.switch', {
    wrapper: {
      position: 'relative',
      height: 32,
      verticalAlign: 'middle',
      userSelect: 'none',
      display: 'inline-flex',
      mr: 72,
      alignItems: 'center',
      cursor: composeStyle.when('disabled')
        .truthy('not-allowed')
        .falsy('pointer'),
      color: composeStyle.when('disabled')
        .truthy('palette.body.disable')
        .falsy('body'),
    },
    switchInput: {
      border: '0',
      clip: 'rect(1px, 1px, 1px, 1px)',
      height: '1px',
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      whiteSpace: 'nowrap',
      width: '1px',
      opacity: '0',
      [disabledCircleState]: {
        bg: 'palette.ash.disable',
        cursor: 'not-allowed',
      },
      [disabledCheckedCircleState]: {
        bg: 'palette.brand.disable',
        '& > div': {
          left: composeStyle.switch('size')
            .case('s', 'calc(100% - 14px)')
            .case('m', 'calc(100% - 22px)'),
        },
      },
      [checkedCircleState]: {
        bg: 'brand',
        '& > div': {
          left: composeStyle.switch('size')
            .case('s', 'calc(100% - 14px)')
            .case('m', 'calc(100% - 22px)'),
        },
      },
    },
    controlSize: {
      m: {
        px: 6,
        width: 48,
        fontSize: 12,
        lineHeight: 24,
        height: 24,
      },
      s: {
        px: 2,
        width: 28,
        fontSize: 12,
        lineHeight: 16,
        height: 16,
      },
    },
    control: {
      borderRadius: '40px',
      display: 'flex',
      alignItems: 'center',
      bg: 'ash',
      color: 'white',
      transition: 'background-color .1s cubic-bezier(.4,1,.75,.9)',
      position: 'relative',
    },
    controlCheckedSize: {
      m: {
        size: 20,
      },
      s: {
        size: 12,
      },
    },
    controlChecked: {
      left: '2px',
      bg: 'white',
      transition: 'left .1s cubic-bezier(.4,1,.75,.9)',
      borderRadius: 'circle',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
    },
    label: {
      ml: 4,
      fontSize: '14px',
    },
  })]
}
